// extracted by mini-css-extract-plugin
export var container = "ResponsiveSVG-module--container--4ddbb";
export var svg = "ResponsiveSVG-module--svg--b7d35";